export class AppError extends Error {
  code: string;
  data?: any;

  constructor(code: string, data?: any) {
    super(code);
    this.name = 'AppError';
    this.code = code;
    this.data = data;
  }
}
